export const INTERVIEWS = [
  {
    id: 0,
    date: "2026-03-19",
    title: "AI 監理、穩定幣與資產代幣化",
    expert: {
      name_ch: "楊岳平",
      name_en: "Yueh-Ping (Alex) Yang",
      title: "臺灣大學法律學院 教授",
      email: "alexypyang@ntu.edu.tw",
      avatar: "/yueh_ping_yang.jpg",
    },
    tags: ["AI監理", "穩定幣", "資產代幣化", "個資保護", "金融法規"],
    intro:
      "臺大金融科技研究中心邀請臺大法律學院楊岳平副教授（同時擔任本中心金融法律組成員）蒞臨交流，就當前金融科技發展中的幾項重要議題進行分享與討論，包括人工智慧監理與可解釋性問題、金融主管機關在人工智慧與資料分享上的政策定位，以及穩定幣對金融體系可能帶來的影響等面向。楊教授從法律與監理的角度出發，結合金融實務的發展趨勢，對相關政策方向與制度設計提出觀察與分析，為理解金融科技治理的未來發展提供了重要的思考。",
    sections: [
      {
        title: "一、人工智慧監理的變局",
        paragraphs: [
          "台灣《人工智慧基本法》甫於今年(2026)1月14日公布施行。楊教授觀察指出，該法目前主要揭示較多上位原則，在規範上較為抽象，且在操作上尚欠缺具體標準。此外，未來個人資料保護委員會在個人資料管理上的監理立場寬嚴程度也有待觀察。相較於此，金管會對於人工智慧相關議題上的行政指導標準則較為具體，並且使用建議性的文字、採取低度干預的政策方向，讓產業得以漸進學習。",
          "楊教授認為，金融業可以說是人工智慧監管法律走得最前面的產業之一。金管會於2024年6月頒布的金融業運用人工智慧(AI)指引，定有比《人工智慧基本法》更為深入具體的一套人工智慧監管規定，而金融機構本身也承受高度法令遵循壓力，進而對於如何遵循相關規定需求迫切。",
          "針對人工智慧的管理，楊教授特別提出未來深入研究「可解釋人工智慧」（explainable AI）的重要性，並指出可解釋人工智慧的應用目前在技術端與法律端之間仍存在一定落差。法律端已高度關注人工智慧的決策黑盒子風險，但苦於提出具體的解決方案；而技術端雖在可解釋人工智慧有一定發展，但苦於法律或監管欠缺明確的標準而不易具體落地。未來的人工智慧管理發展重點，需要法律端和技術端之間有更好的整合，才能產生更具體的解決方案，例如透過以結果為基礎（outcome-based testing）進行測試評估人工智慧系統的表現與特性，並透過例如公私協力的方式促進政府監管者與民間認驗證機構之間的合作，以發展出產業通用的可解釋人工智慧認驗證標準。",
          "另一個和人工智慧治理切身相關的議題是資料分享。楊教授認為，台灣的金融領域在資料分享上仍存在特別多限制，未來政策方向應該朝能夠讓大家有更多資料分享、有更大的資料集流通而努力，讓資料分享不再被妖魔化。尤其在金融實務上，即使業者基於打詐、ESG等法令遵循目的，願意在資料去識別化後進行分享，主管機關還是難免基於資料保護的風險考量而對資料分享採取較為保守的立場。楊教授指出，歐盟近期也在考慮透過建立安全港（safe harbor）條款適度鬆綁對個人資料使用的管制，以便利業者取得人工智慧模型所需的訓練資料，值得觀察；此外我國亦可考慮利用具有我國特色的機制例如定型化契約範本等方式，推動資料分享與開放資料。",
          "但若從另外一個角度觀察，楊教授表示，我國在資料治理上較為特別之處，在於存在諸如健保資料庫、證券交易所、集中保管結算所、金融聯合徵信中心等政府主導的中心化機構，高度集中保存醫療、證券交易、信用等資訊，因此已有一定的資料彙集。以金融業舉例，在資料保護法規許可的前提下，其實是有機會透過政府的政策協調即可經由這些周邊單位取得具有高度價值的訓練資料。",
        ],
      },
      {
        title: "二、穩定幣在我國的發展前景",
        paragraphs: [
          "近年來，穩定幣對於金融穩定的影響受到矚目。但就貨幣政策的角度觀之，楊教授認為穩定幣的出現並沒有改變存款總量，比較主要的影響是穩定幣發行人把大量準備資產集中存放在少數幾家銀行，因此可能會對銀行間的存款競爭與分配產生影響。",
          "至於就穩定幣的擠兌是否可能引發公債市場擠兌的疑慮，楊教授指出，首先，未來穩定幣的整體市場規模如何，仍有待觀察；其次，這涉及穩定幣發行人的準備資產組成情形，特別是穩定幣發行人利用準備資產投資公債的具體比例，例如歐盟要求穩定幣發行人的準備資產僅須維持百分之三十的銀行存款比例，對於可投資公債的資產比例自然就有一定影響；我國如欲控制公債市場擠兌的疑慮，未來也可建立類似監理制度，控管投資於公債的規模，避免產生太嚴重的公債擠兌效果。",
          "再就中央銀行數位貨幣（central bank digital currency, CBDC）的發展而言，據楊教授的觀察，就零售型CBDC而言，目前我國中央銀行可能偏向採取「備而不用」的策略，並不急著正式全面上路，但做好相關準備，可以在有需要時盡快上路。主要原因可能在於台灣目前的民間支付系統已經相當便利，新台幣在日常交易使用也非常穩固。",
        ],
      },
      {
        title: "三、資產代幣化的政策角色",
        paragraphs: [
          "針對資產代幣化例如債券、基金或股票等資產代幣化的芻議，楊教授觀察指出，除了提升相關資產的交易便利性以外，我國主管機關推動代幣化政策的另一可能出發點，或許亦與建立統一帳本系統有關，透過分散式帳本技術讓更多資產以代幣的形式儲存、彼此串連於一個統一帳本系統，以達到款券同步交割等整合。這樣的推動思維更偏向由政府以建構基礎金融基礎設施的角度在規劃制度，和國際上許多資產代幣化項目主要是由市場需求驅動，可能又有所不同。",
        ],
      },
      {
        title: "四、結語：建構創新與監理並行的金融科技新藍圖",
        paragraphs: [
          "本次交流透過楊岳平副教授的深度剖析，勾勒出台灣在金融科技治理上的關鍵挑戰與機遇。從人工智慧監理中法律端與技術端深度整合的需求，到資料分享如何在「隱私保護」與「AI發展」間取得平衡，乃至於穩定幣與資產代幣化對現有金融基礎設施的重塑，無一不顯示出法律制度必須具備高度的動態適應性。",
          "楊教授的觀點提醒我們，金融科技的發展不只是技術的創新，更是一場關於「信任」與「效率」的制度設計創新。包括公私協力的可解釋人工智慧認驗證標準建立、資料保護安全港條款的適度引入，以及對代幣化資產統一帳本的遠瞻規劃等，都會涉及台灣如何在兼顧效率與安全的目標下發展我國的金融科技生態系。",
        ],
      },
    ],
  },
  {
    id: 1,
    date: "2026-04-20",
    title: "當科技應用於財務領域：效率提升與預測迷思",
    expert: {
      name_ch: "王之彥",
      name_en: "Jr-Yan Wang",
      title: "臺灣大學 特聘教授／臺灣大學國際企業學系 系主任兼國際企業研究所所長",
      email: "jryanwang@ntu.edu.tw",
      avatar: "/jr_yan_wang.jpg",
    },
    tags: ["金融科技", "機器學習", "量化交易", "財務工程", "市場效率"],
    intro:
      "臺大金融科技研究中心邀請臺大國際企業學系王之彥教授暨系主任（同時擔任本中心諮詢委員）進行訪談交流，針對人工智慧、機器學習與金融科技在財務領域中的應用與限制，深入分享其觀察與看法。面對近年市場對AI 技術在金融交易、風險判斷與決策輔助上的期待日益升高，王教授則從市場效率、因果分析與量化交易實務等角度出發，提醒科技固然能提升金融運作效率，卻不宜被簡化為預測未來市場的萬能工具。透過此次訪談，我們也更清楚理解科技進入財務領域後，究竟可能解決哪些問題，又在哪些地方仍須保持審慎。",
    sections: [
      {
        title: "一、機器學習在財務領域的應用：輔助交易，而非預測未來",
        paragraphs: [
          "王之彥教授認為，Fintech 或 Tech 放在財務領域，其主要價值在於降低交易成本、提升交易速度，甚至減少人力或溝通成本，這些確實都可以幫助金融業提升效率。但如果是把 AI 或 Machine Learning 拿來「預測未來」，他認為這件事本身是不切實際的。原因在於市場是有效率的體系，而且是越來越有效率。過去二、三十年前市場對資訊的反應速度可能還沒那麼快，但現在價格幾乎可以即時反應所有資訊。在這樣的情況下，用歷史資料去預測未來，其實是不合理的。像最近美國攻打伊朗這類突發的重大國際事件本身就是無法被預測的，此外，此類事件發生次數少，且每個個別事件都有其獨特之處，幾乎不可能使用過去歷史資料來預測之後市場會發生怎麼反應。",
          "現在很多人會用大型語言模型（Large Language Model）分析新聞或政治人物發言預測市場反應，例如分析川普的發言來預測市場走向，但王教授指出，問題是川普講的話常常跟真正的意圖不完全一樣，模型很容易誤解，即使模型掌握到語意，也不代表可以直接轉成可獲利之交易訊號。此外，很多人會覺得只要蒐集越多資料、越多市場意見，就可以預測股價，但其實股票市場本身就是一個「先行指標」，很多資訊與市場意見，可能早就反映在價格裡了。",
          "再來從研究的角度來看，做研究重視如何解釋因果關係、解釋為什麼價格會動，但 AI 多數時候處理的是關聯（correlation），未必能說明背後真正的因果機制。很多時候其實「只能知道兩者有關係，但不知道為什麼」，這也讓股票市場變得更難理解。",
          "不過，王教授並不否認機器學習在交易上的應用價值，他認為機器學習還是可以幫助獲利，但它比較像是一個最佳化工具。舉例而言，在忽略交易成本的情況下，如果策略勝率原本在 50% 以上，再透過嚴格控制損失、做回測，是有機會把整體獲利機率提高到55%或是60%。但這件事情並不等同於機器學習能夠「預測未來」；真正能獲利的，比較像是「過去跟未來在某種程度上保持一致」，讓你在長期平均下可以賺錢，而不是你真的知道未來會怎麼走。",
          "在量化交易中，重點反而是把所有參數直接丟進去測試，不一定要找出最有解釋力的模型。可能同時跑100種策略，不特別強調哪一個模型最合理，而是關注哪一個模型最終能夠獲利。在這樣的情況下，AI 確實可有助於賺錢，但並不是因為它真正「理解」了市場。",
          "最後，在王教授看來，真正長期賺錢的量化交易者，其實都知道自己是在賺「誰的錢」，但目前 AI 交易面臨的一項重要問題是，許多使用者其實並不清楚自己究竟是在賺誰的錢，這是因為金融市場本質上是由人組成的，而人的決策是無法被AI預測的，所以金融市場下一步的走向也無法被AI預測。",
          "不過 AI或是機器學習在金融領域還是有很實際的用途，王教授指出，像是在信用風險預測上，就很有價值。重點是在眾多資料中找出最關鍵的變數，而不是無限增加變數。王教授另外還舉了一個機器學習在金融領域應用例子：他以前有學生在銀行工作，在2016、2017 年時，銀行還是用電話推銷產品，這位學生把客戶資料丟進機器學習模型，找出哪些特徵組合比較容易提高推銷成功率。電話行銷一開始效果其實不好，但後來成功率提了400%；因然整體的推銷成功率還是不高，對電話行銷而言，這已經是相當顯著的改善。這種應用本質上就是在找出最佳化的特徵組合，雖然沒有很漂亮的理論，但在實務上是有價值的，也確實可以提升效率。王教授認為，金融科技或機器學習放在財務領域，作為效率提升與決策輔助工具有較明確的意義，但若期待其能夠直接「預測」未來市場，本質上就有問題。",
        ],
      },
      {
        title: "二、怎麼做出轉換領域的選擇：從資工到國企",
        paragraphs: [
          "王教授提到，自己大學與碩士階段皆就讀臺大資訊工程學系，而且成績不差，原本是可以循著既有路徑往資工博士走的。但他在大四的時候開始有一個很大的疑問：資工領域的知識與技術更新速度太快，學完之後發現很多東西其實很快就過時了；同時資工這個領域的進入障礙沒有想像中高，新進者進入成本相對較低，技術更新速度又非常快，在現在AI時代，這種現象更是明顯，可能每三個月、每半年就會有新的東西出來。王教授當時開始思考如何建立「進入障礙」這件事，也在想如果要轉領域，應該轉去哪裡。對他而言，物理、數學等學門雖然基礎深厚，但發展時間長，進入難度高，追求卓越不易。相較之下，財務工程是新興的領域，例如此領域最有名的公式，Black-Scholes model 於 1973 年才提出，且當時此領域也備受華爾街金融機構推崇，對當時身處 1990 年代的他而言，財務工程是一個相對新穎、且能夠結合數學與資訊技術能力的方向，因此成為他的選擇。",
          "不過王教授也指出，後來到 2008 年發生金融海嘯之後，財務工程這個領域遭遇相當大的質疑，大家開始反思，如果連金融海嘯這麼大的危機或是會造成如此深遠的影響都無法預測，那這些財務工程模型到底有什麼用？也在那之後，不管是業界還是學界，其實在財務工程上的創新都有點停滯，甚至很多財務工程研究所課程開始換名字，變成資料科學（Data Science），除了原本的財務工程課程內容，還多加上了大數據分析，甚至演變至今，還加入了Fintech與AI的相關內容。王教授也提到，台灣在 2008 年之前有很多學者在做財務工程相關議題，但金融海嘯之後，這條路的難度突然變得很高，但他仍堅持繼續走這條路，到現在已經快 20 年了，他現在回頭看，還是覺得自己當初的選擇沒有問題，重點是要對自己的選擇有信心。",
          "作為國企系教授，王教授認為國企系最大的價值其實是「多元」。學生進來之後可以接觸不同領域，慢慢找到自己真正喜歡的方向。國企系的畢業生可以選擇去金融業、會計業、管顧業或是行銷業，這都是在國企系這段期間，多方學期嘗試後覺得真的喜歡，最終才會選擇這些行業。但相對地有些強調專業能力的系所，學生可能念到後來才發現自己不喜歡這個領域，因為在 17、18 歲的時候，高中生根本不知道自己未來要做什麼。所以重點不是一開始選對，而是要有機會多方嘗試，最後找到自己真的想做的東西。在國外其實也是這樣，就是一個Business School的概念，讓學生在商管領域中自由學習，擁有更多選擇。",
          "但王教授也特別強調，就算是在管院，「數學、程式、統計」這些能力還是非常重要。很多人會誤以為讀管院就不需要這些，但這其實是不合理的。因為如果你將來想要做財務工程或是繼續深造，這些基礎能力還是一定要具備，不然未來真的要跟別人競爭的時候，會拿不出東西。尤其是台大的學生，之後一定會遇到很強的對手，例如中國的學生，他們在讀書動機跟投入程度上都很強，所以在大學的時候其實應該要更努力一點，把這些基礎打好。總結來說，他的想法不是叫大家一定要走某一條路，而是要在過程中多嘗試、保留選擇，同時把基本能力準備好，這樣未來面對選擇時，才能真正擁有選擇，而非只是被現有條件所限制。",
        ],
      },
      {
        title: "三、結語",
        paragraphs: [
          "本次訪談中，王教授提到「科技用在財務領域是沒有問題的」。因為整個金融業其實一直在做一件事，就是盡量降低對「人」的依賴，能用機器就不用人、能自動化就不靠人力。從這個角度來看，Fintech 本身就是以一定程度的容錯空間，換取更高的效率與更低的成本，這其實是整個產業現今持續推進的重要趨勢。",
          "他也提到，為什麼不是有錢就可以開銀行，其中一個很重要的原因就是「系統」本身的價值非常高。今天如果要營運一家銀行，人力成本很高，但更關鍵的是背後的系統與基礎設施，這也是為什麼金融業會越來越依賴科技。而在貨幣的發展上，王教授認為像比特幣這類的虛擬資產未必有其實際價值，但「虛擬貨幣」這件事情本身是一定會發生的，未來很可能會走向電子化的貨幣形式，以降低交易成本與增進交易效率。科技在財務領域的影響是確定的，只是形式還在演變。",
          "但回到最核心的問題：科技或 AI 能不能預測金融市場？王教授其實仍持保留態度。他指出，因為金融市場本質上就是在預測未來，而這件事情本身就很困難。即使 AI 可以給出一套看起來很合理的邏輯或理由，也不代表結果就一定準確，因為市場不只是冷冰冰的數據，而是由人這個有機體的行為所組成。",
          "最後，在對學生的建議上，王教授強調應該多去嘗試不同領域，把不同能力整合起來才是最重要的。與其過早把自己限制在某一條路上，不如在過程中累積多元能力，如此未來面對選擇時，才更有可能掌握主動性，也擁有更寬廣的發展空間。",
        ],
      },
    ],
  },
  {
    id: 2,
    date: "2026-05-07",
    title: "交易越方便，決策越理性嗎？談數位時代下的散戶行為與風險意識",
    expert: {
      name_ch: "莊文議",
      name_en: "Wen-I Chuang",
      title: "臺灣大學財務金融學系暨研究所 副教授",
      email: "wichuang@ntu.edu.tw",
      avatar: "/wen_i_chuang.png",
    },
    tags: ["行為財務學", "散戶行為", "過度自信", "處置效果", "風險意識"],
    intro:
      "臺大金融科技研究中心本次邀請到臺大財務金融學系莊文議副教授（同時擔任本中心金融業務組成員），從行為財務學與投資人決策的角度探討，剖析數位交易環境如何改變散戶投資人的行為模式。隨著手機下單、線上交易平台、投資社群與 AI 工具日益普及，投資資訊的取得變得前所未有地容易，交易門檻也大幅降低；然而，便利並不必然帶來更理性的決策，反而可能放大投資人的過度自信、控制幻覺與衝動交易的行為偏誤。談及數位化交易對年輕投資人、當沖行為、一股交易制度以及停利、停損心理的影響，莊教授提醒，當交易限制降低、交易操作變得更即時且依賴直覺，市場參與度固然可能提升，但投資人也更容易在未充分理解風險的情況下進場，甚至因同儕影響、短期獲利誘惑或假專家資訊而不自覺承擔過高風險。這些現象不只是個別投資人的選擇問題，也反映出金融科技發展下，投資人教育與風險意識建立的重要性。",
    sections: [
      {
        title: "一、散戶常過度自信",
        paragraphs: [
          "在手機下單變得很方便之後，投資人更容易出現過度自信。莊教授指出，這樣的交易環境其實會改變投資人的行為模式。學者使用券商資料研究發現，那些從電話下單轉成線上或手機交易的人，在轉換前績效其實不錯，但轉換之後交易變得更頻繁、也更投機，反而讓績效變差。",
          "這背後一個關鍵是心理學的「控制幻覺」。當投資人自己用手機操作時，會覺得一切都在掌握中，進而更有信心去下判斷而作交易，但這種掌控感很多時候只是主觀感受，並不代表分析真的有比較精準。",
          "同時，網路資訊變多，也讓人更容易產生「知識的幻覺」，以為自己知道很多，但其實只是資訊變多，不一定理解更深。尤其在現在 KOL、AI 工具很普及的情況下，反而更容易產生「我有優勢」的錯覺，進一步放大過度自信。但當大家越依賴相同的資訊來源時，其實並無資訊優勢可言。",
          "結果就產生一個很直覺的行為：開始頻繁交易。而交易一多，手續費和成本就會慢慢吃掉報酬，績效自然變差。",
          "另外也要認清一點，真正有資訊優勢的通常是法人，他們有專業研究團隊在做分析，會親自拜訪上市櫃公司，取得比散戶更精準的資訊，散戶很難靠資訊贏過他們。而且真正有效的策略通常不會被公開，因為一旦大家都使用相同的交易策略，就很難再賺取超額報酬。投資 KOL 可能會在短期影響股價，但當大家一窩蜂進場時，價格往往已經被推高，變成追高。",
          "所以如果投資不是建立在資訊優勢上，其實更合理的方式是接受市場水準的報酬率。長期來看，要穩定打敗大盤很難，因此像指數型 ETF 這種低成本投資工具，反而更適合多數人。與其覺得自己能掌控市場，不如降低交易頻率，用長期和低成本去累積報酬。",
        ],
      },
      {
        title: "二、交易數位化造成的不理性行為",
        paragraphs: [
          "手機下單的便利，讓投資這件事變得比較沒有真實感，也讓投資人對風險的感受變得比較遲鈍，因此更容易出現不理性的加碼行為。莊教授也提到，數位化交易會改變投資人對風險的認知，讓人更容易在不自覺中承擔更高風險。就像用現金消費和刷信用卡的差別，信用卡是消費之後才付款，會讓人不自知放大自己的消費能力；在投資上也是一樣，用手機下單少了實際金錢流出的感覺，容易低估風險、放大投資金額。",
          "這種缺乏真實感的狀態，也會讓投資人更偏向投機。像台灣現在很多年輕人在做當沖交易，追求快速進出、短期獲利。手機操作很直覺，甚至會形成一種習慣性的反應，在市場波動時很容易不自覺加碼。尤其當沖交易如果當天完成，其實不需要真的拿出全部資金，更進一步降低對風險的感知，讓人更容易承擔過高風險。",
          "在學術上，投機性股票通常會用價格波動來區分。像美國股市沒有漲跌幅限制，價格波動幅度較大，投機性相對較高；相對來說，價格較穩定的股票，風險較低，也比較不容易被視為投機標的。通常波動越大、價格變動越劇烈，就越容易吸引追求短期報酬的投資人。",
        ],
      },
      {
        title: "三、一股交易可能帶來的影響",
        paragraphs: [
          "近期台灣開始討論是否改成像美國一樣，以一股為單位進行交易，而不是現在的一張 1000 股。莊教授認為，如果改成一股交易，最大的改變會是交易門檻大幅降低。過去需要較大資金才能買進的股票，未來用很小的金額就可以參與，整體交易量可能因此上升，有助於提升股市的流動性，政府的交易稅收也會增加。",
          "影響最直接的是散戶。對資金有限的投資人來說，確實有機會參與高價股，但同時也代表進場的門檻變低，更多人會進入市場。學術研究發現，市場中的交易限制越多，越能抑制不理性的交易行為；反過來說，當限制減少、交易變得更容易時，也更容易放大投資人的衝動與行為偏誤。",
          "這點其實可以從過去政策看到。2017 年當沖交易稅從原本的千分之 3 降到千分之 1.5，交易成本下降後，市場交易明顯變得更熱絡，也讓小資金可以操作較大的部位，當沖行為明顯增加。實務上，當沖多半集中在資金不多的年輕投資人身上，很多人追求短期快速獲利，甚至有「等一到三個月太慢」的心態，更容易出現衝動交易。",
          "近年一些違約交割案例，金額其實不大，很多也和當沖有關。背後常見的行為模式是，在手機下單的便利下形成習慣性操作，加上同儕影響，原本沒有做當沖的人，也可能因受朋友的影響而開始參與。",
          "莊教授也提醒，當交易限制降低，例如未來若改為一股交易，可能會讓更多原本因資金不足而無法進場的投資人進入市場。這雖然提高了參與度，但也可能讓更多人在缺乏風險意識的情況下承擔風險，更容易出現不理性交易，在市場中為人作嫁。",
          "至於一股交易若再結合當沖，是否會進一步放大負面效果，目前仍需要更長期觀察，但可以預期的是，當門檻持續降低、交易越來越方便時，投資人的行為偏誤可能會被進一步放大。",
        ],
      },
      {
        title: "四、為什麼賺一點就想賣，賠錢卻一直抱著？",
        paragraphs: [
          "我們也問到，為什麼在數位平台上，看到帳面小賺就很想趕快落袋為安，但一旦賠錢卻很容易選擇性忽視，一直放著等它漲回來？莊教授提到，這其實是學術上很典型的現象，叫做處置效果 disposition effect。",
          "這可以用兩個心理學賭局來理解。第一個是利得情境：直接給你 2 萬 4，或是 25% 拿 2 萬 5、75% 拿不到錢。大多數人會選前者，寧願拿確定但比較少的錢，也不願意去賭期望值更高的選項。對應到投資上，小賺的時候會想先賣，因為只要賣掉，就等於把這筆利潤鎖住。",
          "但在損失情境就反過來。如果是確定賠 7 萬 5，或是 75% 機率賠 10 萬、25% 不賠，大多數人反而會選後者。因為有機會不賠，所以會想繼續撐著。這就像股票虧錢時的心態，不願意認賠，會想等回本，甚至反敗為勝。",
          "也就是說，在賺錢時大家偏好確定性，在賠錢時反而會去追求不確定性。再加上同樣金額下，虧損帶來的痛苦大約是獲利的 2 到 2.5 倍，所以人會特別想避免把損失實現，寧願先放著不面對。",
          "這也是為什麼很多人不願意停損。因為一旦賣掉，就等於承認自己做錯決策，心理上會很不舒服，所以會給自己理由繼續持有。但學術研究發現，被投資人賣掉的上漲股票，後續往往還會繼續漲；反而那些被抱著不賣的虧損股票，通常會跌得更深。",
          "莊教授的建議很直接：如果虧損，要回頭檢視是不是選錯標的，如果是，就應該及時停損，把資金轉去更好的投資標的，從更好的投資標的去反敗為勝，而不是在哪裡跌倒，就堅持在哪裡爬起來。比較好的做法，是一開始就設定好停利、停損規則，照紀律執行，不要在當下找理由。長期來看，一個好的策略不需要每一筆都賺，而是讓整體勝率維持在 50% 到 60% 以上，就有機會穩定累積報酬。",
        ],
      },
      {
        title: "五、給投資人的建議",
        paragraphs: [
          "在數位資訊這麼發達的環境下，很多人反而更容易掉進假專家的陷阱。莊教授認為，這確實和認知捷徑有關。當資訊量變得非常龐大時，人會傾向用比較簡單、快速的方式去判斷事情，在心理學上這種方式叫捷思（Heuristics）。問題是，這種依賴簡化與片面資訊的判斷，通常不會帶來好的決策。",
          "而假專家的內容，剛好就是利用這一點。他們的資訊通常很簡單、結論很明確，看起來很容易理解，也很容易讓人直接做出判斷。但其實背後往往是片面的分析，甚至是不完整或錯誤的資訊。在資訊少的時候，大家可能還會去驗證真假；但當資訊變多，反而更不容易一一查證，加上不想花時間，就更容易直接相信。",
          "另外也有一部分原因是貪心，或是對風險沒有足夠警覺，讓人更容易被吸引。",
          "在這樣的環境下，莊教授的建議其實很明確：散戶不要把策略建立在資訊優勢上。當你認知到自己不是資訊優勢者，其實投資方式就會很清楚。可以設定一個比較務實的目標，例如取得接近大盤的報酬就好，而不是每次都想打敗市場。像是投資指數型 ETF，本質上就是跟著整體市場走，而不是做短進短出。",
          "例如投資台灣市場，就問自己對台灣經濟有沒有信心；投資美國市場，就問自己對美國長期發展有沒有信心。如果答案是有，那長期持有像 0050、0056 或是 S&P 500 這類已經篩選過的標的，其實就能跟著大盤成長。市場長期是向上的，但不是每一檔個股都是如此。",
          "另外一點是，不要太常和別人比較，也不要過度討論投資。因為這很容易引發情緒作祟，甚至產生不理性的行為，例如看到別人賺錢就想跟單，或是開始做當沖。這種行為有時候也帶有一點控制幻覺，以為透過更多討論就能提高勝率。",
          "比較好的方式是，把重點放在有意義的決策，例如資產配置、投資目標與紀律執行，而不是每天關注短期漲跌或別人的績效。簡單來說，在資訊爆炸的時代，與其追求比別人知道更多，不如先認清自己不具資訊優勢，然後用長期、低成本、有紀律的方式去投資，反而更穩定。",
        ],
      },
      {
        title: "六、結語",
        paragraphs: [
          "莊教授的觀察提醒我們，金融科技讓投資更便利，但便利本身並不等於投資能力的提升。手機下單、即時資訊、社群討論與 AI 工具確實降低了投資參與門檻，卻也可能讓投資人更容易高估自己的判斷力，忽略市場中的資訊落差與交易成本。對多數散戶而言，真正需要面對的問題，並不是如何取得更多資訊，而是如何辨識自己是否真的具備資訊優勢，以及能否在情緒波動中維持紀律。",
          "從過度自信、處置效果到假專家資訊的影響，莊教授在訪談中指出，投資決策往往不是純粹理性的計算，而是深受心理偏誤、交易環境與社群氛圍左右。當投資人看到小賺就急著獲利了結，面對虧損卻遲遲不願停損，背後其實反映出人們對獲利與損失的感受並不對稱；而當交易越來越容易、成本感受越來越低，這些原本就存在的人性偏誤，也可能被進一步放大。",
          "因此，在數位交易時代，投資人與其追求短期勝率或相信自己能掌握市場，不如回到更基本也更困難的問題：設定合理目標、理解自身風險承受度、建立資產配置與停利停損規則，並避免讓投資決策被短期漲跌、他人績效或社群情緒牽著走。對一般散戶而言，承認自己未必具備資訊優勢，並不是消極，而是一種更成熟的風險管理。長期、低成本、有紀律的投資方式，或許不如短線操作刺激，但往往更能讓投資回到財務規劃的本質，而不是變成一場被情緒推著跑的市場遊戲。",
        ],
      },
    ],
  },
  {
    id: 3,
    date: "2026-05-29",
    title: "從日本經驗看虛擬資產監理革新與我國法制挑戰",
    expert: {
      name_ch: "蔡英欣",
      name_en: "Ying-Hsin Tsai",
      title: "臺灣大學法律學院 教授",
      email: "ytsai@ntu.edu.tw",
      avatar: "/ying_hsin_tsai.jpg",
    },
    tags: ["虛擬資產監理", "日本法制", "穩定幣", "DAO", "金融法規"],
    intro:
      "在全球數位資產市場持續擴張之際，虛擬資產如何納入既有金融監理體系，已成為各國共同面對的重要課題。相較於我國仍在逐步建構虛擬資產專法及監理架構，日本近年在制度推進上步調較快，對於虛擬資產交易、穩定幣、內線交易規範及DAO組織法制等議題，均已累積相當值得參考的實務與制度經驗。為此，臺大金融科技研究中心邀請到臺大法律學院蔡英欣教授（同時擔任本中心金融法律組成員），從日本法制改革出發，探討虛擬資產監理的制度選擇及其對臺灣未來發展可能帶來的啟發。",
    sections: [
      {
        title: "一、日本加密貨幣法制的革新",
        paragraphs: [
          "日本將2026年訂為國家「數位元年」，監管架構由《支付服務法》(Payment Service Act)升級至證券法律體系，將加密貨幣納入《金融商品交易法》（相當於我國證券交易法），並與股票、債券、衍生性金融商品等傳統證券一同監管。蔡教授首先分享到，日本對於加密資產之法制發展，係由支付工具監理逐步轉向投資商品監理，其演進過程反映日本市場對加密資產之功能變化與投資人保護之需求。日本最初對此進行規範之背景，係源於2014年Mt. GOX交易所破產事件，大量比特幣遭竊，暴露出交易所缺乏法制監督及客戶保護之問題。為建立市場秩序，日本於2016年修正《支付服務法》（2017年施行），縱使未正面定義虛擬資產，該法首度將虛擬資產交易所納管，建立交易所登錄制度，要求業者遵守客戶資產分別管理、反洗錢及內部控制等規範。當時立法思維是將比特幣等虛擬資產定位為「支付工具」，而非金融投資商品。",
          "然而，日本虛擬資產市場之快速發展，遠超過當時之立法預期。2018年Coincheck交易所遭駭事件，再度暴露虛擬資產之保管與內控機制不足，日本遂於2019年修正支付服務法（2020年施行），除了將「虛擬資產」更名為「加密資產」外，更強化冷錢包之保管義務及加密資產招攬行為之監理等。其後伴隨NFT、DeFi、穩定幣及Web3生態之興起，日本陸續進行穩定幣制度及信託架構之修正。而在同時，法制上被定位為支付工具之加密資產，其在市場上卻已逐漸轉向為投資運用之標的。依據日本金融廳之統計數據，2025年1月底之時點，日本加密資產帳戶已超過1200萬戶，預託資產超過5兆日圓，且相關申訴案件持續增加。顯示出日本對於加密資產之使用，已不再只是支付工具，轉而成為廣泛流通之投資標的。",
          "為了回應上述使用模式之轉變，2026年日本金融商品交易法擬進行修正，將加密資產從支付服務法改由金融商品交易法進行規範。不過，日本金融廳強調，此次修法並非將加密資產等同有價證券，而係建立一套適合其特性之規範架構，其核心是在「可評價化」而非「證券化」，亦即，使加密資產得於與股票、債券等資產相同之制度基礎上進行比較與評估。修法之重點在於，建立資訊揭露制度、導入不正行為之規範及強化交易所及相關業者之治理義務。",
          "我國目前在立法院審議中之《虛擬資產服務法》一旦通過，勢必能對虛擬資產業者之監理，發揮很大作用。惟從日本法之經驗可知，虛擬資產之使用如係以投資為主要目的，未來我國立法者或可檢討將證券交易法之相關規範模式套用到虛擬資產上。",
        ],
      },
      {
        title: "二、穩定幣的發展路徑",
        paragraphs: [
          "蔡教授指出，日本在2022年支付服務法修正後（2023年施行），創設「電子支付工具」制度，即以法定貨幣作為價值基礎、可作為支付工具之使用並以電子方式進行移轉者，其本質上即為日本法之穩定幣。在支付服務法中，對穩定幣係採取高度管制模式，其核心理念在於確保持有人得以按面額受到償還。其次，因穩定幣之發行與償還被認為構成「匯兌交易」，故其發行主體僅限於銀行、資金移轉業者及信託公司。同時，從事穩定幣之買賣、交換、媒介及管理者，須另行取得業者登錄。在資產保全方面，日本要求穩定幣業者須有足額資產保全。",
          "日本對穩定幣法制面之建構，雖早於其他先進國家，但將穩定幣真正商業化，則較美國起步晚。日本目前在穩定幣之發展上，三菱UFJ信託銀行所開發之「Progmat Coin」平台，係提供給銀行及企業發行日圓穩定幣之基礎設施；而日本三大金融集團（三菱UFJ、三井住友及瑞穗）則共同合作推動跨境支付穩定幣之計畫，期能利用穩定幣改善國際匯款效率。另一方面，日本從2024年開始，允許海外發行之穩定幣的流通，例如美元穩定幣USDC可以透過日本交易所及合作之金融機構進入日本市場。",
        ],
      },
      {
        title: "三、去中心化資產的市場監理困境",
        paragraphs: [
          "日本對去中心化資產之市場監理，目前尚未建構獨立專法。日本支付服務法先前曾以比特幣等具有支付功能之加密資產作為規範對象，但對於近年出現之DAO、DeFi等所謂去中心化生態，已遠超過當時在法制度設計之預期。也因此，產生究竟應適用支付服務法中加密資產之規範，抑或適用金融商品交易法中有關有價證券之規範的問題，亦即，在無專法前提下，目前僅能在既有法規框架下回應去中心資產之監理困境。",
        ],
      },
      {
        title: "四、去中心化自治組織(DAO)的治理議題",
        paragraphs: [
          "日本在2024年4月22日正式允許設立「有限責任公司型DAO」（合同会社型DAO），讓去中心化自治組織（DAO）在日本國內取得正式的法人地位。蔡教授認為，由於DAO強調去中心化自治，相較於日本公司法中之合同會社（類似我國有限公司，但不設董事，由社員直接執行業務，且章程自治範圍極大）須設置業務執行社員，因此產生去中心化與公司法中心治理結構間之差異。實務上，日本DAO協會提出以DAO總會與治理代幣（governance token）模式，由持幣者投票決定重要事項，而業務執行社員原則上遵守DAO決議，以維持自治性與民主性。近期，日本學者則關注治理代幣之法律定性，其究竟是財產權？抑或兼具公司社員權與治理權？此外，DAO亦衍生出表決權集中、少數社員保護及責任歸屬等治理議題尚待解決。",
        ],
      },
      {
        title: "五、結語",
        paragraphs: [
          "最後，蔡教授分享到，日本在虛擬資產法制的建構上相較於我國更具前瞻性，率先將虛擬貨幣交易業者納入監管；在法制先行的引導下，在日本，加密貨幣交易帳戶已經達到1500萬、交易量高達5兆日幣。日本在虛擬資產監理上的路徑選擇，可供我國主管機關以及立法者作為參考。",
          "此外，日本法律學界在金融監理外，對於虛擬資產法律議題進一步的研究，包括虛擬資產代幣的移轉和現實資產移轉的時間點應如何認定等問題，都值得我國產官學界借鑑。",
        ],
      },
    ],
  },
  {
    id: 4,
    date: "2026-07-23",
    title: "新科技照見既有法制的問題",
    expert: {
      name_ch: "邵慶平",
      name_en: "Ching-Ping Shao",
      title: "臺灣大學法律學院 特聘教授",
      email: "cpshao@ntu.edu.tw",
      avatar: "/ching_ping_shao.jpg",
    },
    tags: ["人工智慧", "金融科技", "虛擬資產", "自動化交易", "金融法規"],
    intro:
      "人工智慧、金融科技、虛擬資產與自動化交易系統的快速發展，正不斷挑戰既有法律制度的適用界線。同時值得思考的是，科技的出現，往往使我們重新看見既有法制中早已存在、卻未被充分處理的結構性問題。臺大金融科技研究中心邀請臺大法律學院邵慶平教授（同時擔任本中心金融法律組成員）進行訪談交流，針對新興金融科技照見既有法制之問題，深入分享其觀察並探討法律制度在科技快速變遷下可能面臨的調整方向。",
    sections: [
      {
        title: "一、新科技照見既有法制的問題",
        paragraphs: [
          "人工智慧、金融科技、虛擬資產與自動化交易系統的快速發展，正在不斷挑戰既有法律制度；然而，面對新科技，法律真正需要處理的問題，未必只是「如何管制科技」，更可能是科技的出現，讓我們重新看見既有法制早已存在的缺陷。",
          "邵慶平教授指出，法律與新興技術的互動，並非人工智慧時代才出現的全新課題；早在網際網路興起之時，法律便已面臨類似的調適問題。面對人工智慧、金融科技等新技術，法律人首先應嘗試在既有法制中尋找可適用的規範架構；但更重要的是，當新技術與既有制度發生摩擦時，法律人不應立即將問題理解為「新科技不守法」，而應進一步反思：是否既有法制本身即存在過度僵化、手段單一或比例失衡的問題。",
          "邵教授認為，臺灣法制長期以來的一項重要缺陷，是欠缺「管制手段的多元性」。在許多領域中，立法者或執法者面對風險時，往往直覺地訴諸刑罰，甚至透過加重刑度來回應社會疑慮；然而，新興科技的發展本身具有高度不確定性，創新者、研究者或創業者在探索新模式時，難免會碰觸既有法制的灰色地帶；如果法律效果一開始便是重刑，則即使行為人並無惡意，也可能因為一時不慎而承受極嚴重的法律後果。這種制度設計，將使創意工作者在投入創新以前，即被迫進行高度保守的成本效益評估，進而壓抑整體社會的創新能量。",
        ],
      },
      {
        title: "二、從重刑思維走向多元管制工具",
        paragraphs: [
          "以金融科技沙盒為例，邵教授指出，沙盒制度的出現，某種程度上正反映了既有法制欠缺彈性的問題；如果原本的法律效果不是一律如此嚴重，而是能夠依行為人的目的、危害程度、涉案金額、資訊揭露程度等因素，搭配行政罰、民事責任、執照管制、限期改善、行為禁止或刑罰等不同工具，則許多創新活動或許不必透過沙盒制度才能取得嘗試空間。換言之，問題未必在於要「放寬」或「加嚴」管制，而在於法律是否能跳脫寬嚴二分，建立更細緻的管制光譜。",
          "在金融法領域，邵教授特別以非法匯兌、非法吸收存款等問題為例加以說明。過去銀行法中若干重刑規定，原本多是為了回應投資詐欺等嚴重社會問題；但當金融科技業者以新型態技術或商業模式進入市場時，若一概被放入既有刑罰框架中處理，便可能忽略不同案件之間的實質差異。邵教授強調，金融科技或人工智慧的出現，並不是讓原本完美的法律變得不完美；相反地，它往往讓我們看見既有法制本來就存在的問題；也因此，與其只問新科技是否適合既有法律，不如進一步追問既有法律是否早已需要被重新檢討。",
          "在區分管制手段時，邵教授認為，法律不應只停留在刑罰、行政罰與民事責任的傳統分類，而應回到制度目的與行為本身來思考；若某一行為造成社會危害，法律當然需要回應，但回應方式不必然只能是刑罰。舉例而言，沒收、罰鍰、損害賠償、執照撤銷、行為禁止、事前申請、資訊揭露與事後監督，都可能是法律用來回應風險的工具；真正重要的，是在不同情境中選擇適當的手段，而非一開始就以刑罰作為唯一答案。",
          "邵教授也提醒，在討論「善意」與「惡意」時，不能僅依傳統法律概念作形式判斷。這裡所謂善意與惡意，重點不只是法律上抽象的善意或惡意，而是行為人是否具有詐欺、侵害他人或規避法規的意圖。例如，在虛擬資產或金融科技案件中，有些行為表面上被包裝為創新商業模式，但實際上就是投資詐欺；這類案件自應由執法機關蒐證並嚴肅處理。但同時也必須承認，在新型態商品與服務中，確實存在許多難以立即判斷的灰色地帶；正因如此，若管制手段能夠更多元，法律便不必在每一個不確定案件中都急於判斷是否構成刑事犯罪。",
        ],
      },
      {
        title: "三、人工智慧交易與市場公平的界線",
        paragraphs: [
          "談及人工智慧交易系統與高頻交易，邵教授認為，這類技術使投資市場面臨更複雜的法律問題。人工智慧可能協助交易者尋找市場中的套利機會或制度漏洞，並藉此獲取大量利益；從執法者角度觀察，這樣的行為可能被質疑為操縱市場，但從另一個角度來看，若交易是真實交易，且行為人只是發現並利用既有制度中的缺陷，法律是否應立即動用重刑，仍值得反省。",
          "邵教授以「黑客松」作為比喻：若有人找出系統漏洞，制度的第一個反應未必應該是處罰找出漏洞的人，而是回頭檢視漏洞為何存在，以及是否應將其補起來。當然，這並不表示任何利用漏洞的行為都值得鼓勵；但至少說明，面對人工智慧交易或程式交易時，法律不應只問「是否有人賺了大錢」，而應更精確地分析該行為是否涉及虛偽交易、詐欺意圖、資訊不對稱的濫用，或對市場公平性造成實質破壞。",
          "在規則設計上，邵教授亦指出，法律規則並非越明確越好。明確規則固然能提供市場參與者安全感，但也可能釋放出另一種訊號：只要形式上遵守規則，即使實質上規避制度目的，也不會發生法律責任。因此，在某些市場行為中，立法者有時必須謹慎思考，是否應保留一定程度的不確定法律概念，以提醒市場參與者不可只從形式規則尋找套利空間；相對地，若立法者選擇設計明確的安全港，就必須確保該安全港真的能帶來穩定預期，而不應發生主管機關認為安全、檢調機關卻認為違法的矛盾情形。",
          "對於人工智慧交易系統是否應採牌照制、事前檢核或落日條款等方式管理，邵教授則抱持較為保留的態度。他認為，事前管制固然有其可能性，但也可能大幅壓抑創意。人工智慧技術本身存在一定的不可解釋性，若要求創新者在事前即完整說明其系統如何運作，未必符合技術發展的現實；因此，相較於強化事前審查，邵教授更傾向於從市場行為本身進行管制，並透過事中、事後的觀察與制度修正，使市場逐步變得更加公平。",
          "邵教授也提到，人工智慧交易背後的技術，對業者而言往往屬於營業秘密。若要求其完全揭露，可能不利於創新與競爭；但若完全不管，又可能使一般投資人擔心無法參與人工智慧帶來的市場利益。對此，邵教授認為，主管機關與立法者應將市場公平放在心中，持續研究新技術對市場結構的影響；某些金融商品或市場機制，例如ETF，也可能在一定程度上使小額投資人分享市場發展成果，而不必完全依賴對人工智慧交易系統的強力管制。",
        ],
      },
      {
        title: "結語：法律面對創新的思維需要更新",
        paragraphs: [
          "整體而言，邵慶平教授對人工智慧與金融科技的觀察，並非單純主張放寬管制，也非一味要求嚴格規範。其核心關懷在於，臺灣法制是否能從新科技帶來的衝擊中，看見既有制度的不足，並發展出更精緻、更具比例感，也更能鼓勵創新的管制工具。新科技不是法治的敵人，而是一面鏡子；它讓我們看見，真正需要被更新的，或許不只是科技規範，而是法律面對風險與創新的整體思維方式。",
        ],
      },
    ],
  },
  {
    id: 5,
    date: "2026-07-23",
    title: "從非結構化資料、人工智慧到因果推論",
    expert: {
      name_ch: "顏汝芳",
      name_en: "Ju-Fang Yen",
      title: "臺北大學商學院副院長兼統計系系主任",
      email: "jfyen@gm.ntpu.edu.tw",
      avatar: "/ju_fang_yen.jpg",
    },
    tags: ["非結構化資料", "人工智慧", "機器學習", "因果推論", "金融研究"],
    intro:
      "臺大金融科技研究中心邀請臺北大學商學院 副院長兼統計系系主任顏汝芳副教授（同時擔任本中心金融業務組成員），分享其從數學與財務工程出發，逐步走向公司理財、資本市場與非結構化資料研究的學術歷程。訪談從企業法說會中的聲音、影像與文字資料談起，說明人工智慧與機器學習如何協助研究者將過去難以系統分析的資訊轉化為可檢驗的變數；同時也強調，技術本身並不等同於研究貢獻。唯有結合扎實的財務知識、清楚的理論問題、嚴謹的研究設計與對真實市場的理解，才能在快速發展的 AI 時代提出具有經濟意義與社會價值的問題。",
    sections: [
      {
        title: "一、從數學到公司理財研究",
        paragraphs: [
          "顏汝芳教授大學就讀臺大數學系，最初因喜愛推理與解題而選擇數學。隨著課程日益抽象，她開始思考如何將數理訓練應用於真實世界，因而在研究所轉向財務工程，並以選擇權定價為碩士論文主題。研究過程中，她逐漸發現，真正吸引自己的不只是模型，而是從問題出發、建立理論並以資料檢驗的研究歷程，之後也進一步轉向公司理財研究。",
          "隨著研究深入，她注意到，許多可能影響企業決策與市場反應的資訊，例如管理者的聲音、表情、文字表達與互動方式，並不會完整呈現在財務報表中。人工智慧與機器學習的發展，使這些非結構化素材得以轉換為可分析的資料；但她的研究核心始終一致，仍是理解企業如何決策，以及市場如何解讀企業所傳遞的資訊。",
        ],
      },
      {
        title: "二、從財務數字到聲音、影像與文字",
        paragraphs: [
          "顏教授指出，公司與金融市場中的決策終究由人作出。財務報表提供重要的量化資訊，但企業與市場參與者之間的資訊傳遞，往往還包含語氣、聲音、表情、敘事方式與即時回應等線索。這些非結構化資訊可能影響投資人如何分配注意力、形成信任判斷，以及解讀同一項財務消息。因此，她的研究也與行為財務學及心理學產生交集，但關注的核心仍是公司理財與資本市場：不僅要檢驗某種聲音、影像或文字特徵是否具有預測力，更要進一步釐清其在何種資訊環境下，透過何種機制影響市場參與者的判斷與反應。",
          "不同資料模態的重要性，取決於資訊傳遞的場景。以企業法說會為例，臺灣法說會的形式較為多元，部分採影音直播或視訊形式，參與者可以同時接收講者影像、簡報與現場互動；美國企業法說會則多以電話會議或音訊為主，投資人主要接觸管理者的聲音、逐字稿與簡報。因此，在不同制度與媒介環境中，聲音、影像與文字的重要性並不相同。顏教授認為，財金研究不能只停留在財報上的數字，也必須理解這些數字如何被說明、被呈現，以及最終如何進入市場的資訊處理與價格形成過程。",
        ],
      },
      {
        title: "三、從原始素材到可驗證的變數",
        paragraphs: [
          "處理非結構化資料的第一步，不是先選擇最流行的模型，而是先清楚定義研究構念與衡量方式。以文字為例，過去研究常使用財務字典、TF-IDF、主題模型或詞向量；大型語言模型出現後，研究者還可以透過提示設計、少量範例、微調或語意相似度來進行分類與測量。但無論採用哪一種方法，都必須檢查模型是否真正捕捉研究者想衡量的概念。聲音資料通常會轉換為波形或頻譜，再萃取音高、能量、語速、停頓及聲音品質等特徵；影像資料則可運用卷積神經網路或其他視覺模型進行辨識與預測。顏教授特別強調，標籤（label）的定義是研究品質的核心，例如，若衡量的是外貌吸引力、可信賴感或能力印象等主觀知覺，文獻常見做法為透過足夠數量且彼此獨立的受評者提供評分，檢驗評分一致性後，再用於模型訓練與樣本外驗證。AI產生的標籤可以作為輔助，但不能取代人工檢核與外部驗證。不同資料適合不同方法；真正重要的不是模型有多複雜，而是變數是否可信、是否可重複，以及是否能回答原先的研究問題。",
        ],
      },
      {
        title: "四、預測不等於因果：研究設計的重要性",
        paragraphs: [
          "AI 從影像、文字或聲音中萃取出的訊號，可能具有預測力，但預測力並不等同於因果關係。顏教授從統計與計量經濟的角度說明，量化只是第一步；研究者還必須提出理論機制，並排除反向因果與遺漏變數等其他解釋。若要回答因果問題，統計學與計量經濟學已有一套完整的因果推論方法。研究者必須依據研究問題、資料特性與制度背景，選擇適當的研究設計，並盡可能排除反向因果、遺漏變數及選擇偏誤等其他解釋。其中一種常見做法，是利用可被合理視為外生的變化，例如政策改變、制度調整或自然災害等外部因素，建立處理組與對照組進行比較。以差異中的差異法（Difference-in-Differences, DID）為例，研究者可以比較事件發生前後，處理組與條件相近之對照組的結果變化，藉此評估特定事件或政策可能造成的影響。",
          "顏教授指出：「研究的起點可以來自生活中的觀察，但從觀察走向結論，中間仍需要理論、資料與嚴謹的研究設計。機器學習可以幫助我們看見資料中的規律；因果推論則要進一步釐清，觀察到的變化是否確實由特定事件或政策所造成，而非來自其他同時存在的因素。」",
        ],
      },
      {
        title: "五、AI 如何改變研究者與金融市場",
        paragraphs: [
          "AI 除了提供新的資料處理與分析工具，本身也創造了新的研究問題，例如資訊如何被生成、使用與驗證，以及不同使用者之間的能力差距是否因此擴大。顏教授認為，AI 時代真正稀缺的不是操作工具的能力，而是領域知識、提問能力與判斷能力。具備財務領域知識的人，因為更了解財務報表、現金流、風險、企業制度與資料限制，通常也更能辨識模型回答中的假設、遺漏與錯誤，並透過持續追問取得有價值的資訊。這種理解與提問能力的落差，可能隨著工具普及而進一步擴大。",
          "AI 也改變了人們擷取與消化資訊的方式。一方面，它可能降低取得資訊的門檻；另一方面，大量低品質內容、對模型的過度依賴，以及使用方式的差異，也可能使資訊環境更加嘈雜，甚至加劇資訊不對稱。這些變化也可能進一步反映在金融市場中。因此，研究者除了關注模型的預測準確度，也應檢驗 AI 是否改變投資人的注意力配置、市場反應速度、流動性，以及不同參與者之間的資訊優勢。換言之，AI 正逐漸從分析市場的工具，成為影響市場運作與均衡的一部分。",
        ],
      },
      {
        title: "六、負責任地使用 AI：未來金融人才的核心能力",
        paragraphs: [
          "大型金融機構導入 AI，不只是追求效率與模型準確度，也涉及資料隱私、資安、法令遵循、模型風險與責任歸屬。以會計與審計工作為例，生成式 AI 可以協助整理資料、辨識異常或產生初稿，但輸出內容仍須由專業人員查核來源、評估風險並作出最終判斷。即使報告由 AI 協助完成，簽署與背書的責任仍由專業人士承擔。顏教授強調：「工具可以協助分析，但最終背書的永遠是人。」因此，金融科技教育除了技術，也必須包含治理、倫理與責任意識。",
          "談到未來投入金融研究或金融科技領域的人才，顏教授歸納出幾項核心能力。首先是領域知識與思辨能力：面對任何變數或模型，都要追問它真正衡量的是什麼、背後的理論機制為何，以及是否存在其他可能的解釋。其次是統計與資料分析能力，不僅要理解預測與因果推論的差異，也要能正確解讀並清楚表達分析結果。第三是真實情境的理解，透過實習、研究助理工作、競賽或案例分析，認識制度、資料來源及市場參與者如何決策。第四是溝通與跨領域合作能力，能夠整合不同專業、清楚表達觀點，並對成果負責。",
          "學生不必追逐每一項新工具，更重要的是建立扎實的財金與統計基礎，保持學習新方法的能力，並知道何時可以相信模型、何時必須停下來重新檢查。金融科技不是以技術取代金融，而是以技術拓展研究與實務的可能性；真正決定成果品質的，仍是研究問題、專業判斷與責任意識。",
        ],
      },
    ],
  },
  {
    id: 6,
    date: "2026-08-10",
    title: "從區塊鏈到金融科技：數位資產、安全與新興技術的挑戰",
    expert: {
      name_ch: "薛智文",
      name_en: "Chih-Wen Steven Hsueh",
      title: "臺灣大學資訊工程學系／資訊網路與多媒體研究所 副教授",
      email: "cwhsueh@csie.ntu.edu.tw",
      avatar: "/chih_wen_hsueh.jpg",
    },
    tags: ["區塊鏈", "資產代幣化", "智能合約", "分散式系統", "數位資產"],
    intro:
      "近年來，穩定幣、智能合約與資產代幣化受到關注，區塊鏈也從密碼貨幣的底層技術，逐漸延伸至支付、資產交易與金融服務而形成一種提供信任的機器（trust machine）。然而，區塊鏈進入金融體系後，面對的不只是技術能否運作，也包括現實資產如何認定、外部資料如何取得，以及參與者之間的權責與利益如何分配。為理解區塊鏈在金融科技中的應用與限制，臺大金融科技研究中心邀請國立臺灣大學資訊工程學系／資訊網路與多媒體研究所薛智文副教授（亦為本中心金融科技組成員）進行訪談，從資訊系統與分散式系統的角度，探討資產代幣化、大規模金融應用的技術瓶頸，以及區塊鏈以外的價值交換方式。",
    sections: [
      {
        title: "一、資產代幣化如何實作？",
        paragraphs: [
          "資產代幣化是將資產或相關權利以數位代幣表示，並在區塊鏈或其他可程式化帳本上記錄其持有與轉移。標的可以是貨幣、證券、不動產與商品，也可以是服務、會員資格或社群內的交換權利。若資產權利、轉移條件與收益分配方式能被明確定義，便可將部分規則寫入智能合約（並非所有規則都可以程式化）。",
          "智能合約可以規定代幣如何產生、由誰持有，以及在何種條件下轉移，但它主要處理鏈上資料，無法自行判斷現實世界是否發生特定事件。例如，不動產是否完成登記、商品是否送達，或某人是否符合保險理賠條件，都需要鏈外資訊。當智能合約需要取得市場價格、物流狀態或天氣資料時，通常會透過預言機（oracle）將資訊送上鏈。然而，預言機也帶來新的信任問題，包括資料由誰提供、如何驗證，以及資料錯誤時由誰負責。智能合約可以依輸入執行程式，卻不能保證輸入一定正確。其實，可以把預言機想像成另一個提供可信資料的區塊鏈，跨鏈與多鏈結合之下區塊鏈才能落地。",
          "此外，鏈上代幣完成轉移，不代表鏈下資產已在法律上完成所有權移轉。兩者仍需透過契約、登記、保管與贖回機制建立對應。因此，資產代幣化真正的難題，不只在於程式實作，而是能否在代幣、實體資產、法律權利與責任之間建立可信且可執行的鏈上鏈下合規連結。",
        ],
      },
      {
        title: "二、從技術可行到大規模應用",
        paragraphs: [
          "區塊鏈尚未全面進入支付、清算與資產交易體系，其中一項原因是效能與可擴展性。傳統金融交易通常由銀行、清算機構或支付平台維護集中式帳本；區塊鏈則由多個節點驗證交易並取得共識，可降低單一參與者任意竄改資料的風險，但也增加資訊交換與同步成本。",
          "工作量證明（PoW）透過運算競爭記帳權，能源需求較高；權益證明（PoS）則以質押與懲罰機制約束驗證者，可降低能源消耗，但驗證權仍可能集中於大型質押服務商或少數參與者。交易順序也是關鍵問題：不同節點收到交易的時間可能不同，系統必須決定交易順序，以及衝突交易何者有效。建立區塊的參與者也可能藉由納入、排除或重排交易獲利，形成最大可提取價值（MEV），影響交易公平性。",
          "薛老師的研究關注分散式系統中的全域事件順序與時間戳記，探討如何在缺乏共同時鐘的環境中，讓不同節點對事件先後形成一致判斷。這類問題不只存在於區塊鏈，也涉及分散式資料庫與多節點同步。分片（sharding）則將資料與交易分配給不同節點群組，使多個分片像平行一樣但又不完全是平行或並行地處理任務。也就是，跨分片交易仍需確保無雙花、原子性與最終狀態一致，避免交易在分片後的結果與不分片不相容（未必要一模一樣）。",
          "除了效能，資產保管也是實際應用的重要課題。自我託管錢包讓使用者掌握私鑰，降低對平台的依賴，卻也將保管責任轉移給個人。若私鑰或助記詞遺失，資產可能永久無法取回。區塊鏈若要進入日常金融生活，仍需發展帳戶復原、協助託管與風險分擔機制。新系統也會改變銀行、支付平台、清算機構與監管單位的既有角色。因此，區塊鏈能否落地，不只取決於交易速度，也受到法律規範、轉換成本、責任分配與商業誘因影響。",
        ],
      },
      {
        title: "三、重新理解「去中心化」",
        paragraphs: [
          "「去中心化」容易讓人以為系統中不應存在任何中心或管理者，但實際上，它可以分為帳本維護、交易驗證、系統治理、貨幣發行與服務提供等不同層面。一個去中心化的系統只能盡量「去中心」以防勾串，但並非過於理想的無中心設計（所以加上「化」），如預言機的存在。",
          "去中心化並非將政府、中央銀行或平台全部移除，而是重新判斷哪些權力不必或不可集中，以及哪些情況仍需要明確的決策者與負責者。例如，分散式帳本可以記錄交易狀態，卻不能直接取代中央銀行對貨幣政策的判斷與責任。相反地，若帳本、資料與決策權長期集中在少數機構手中，使用者也必須承擔權力濫用或管理失靈的風險。因此，制度設計的重點，是判斷哪些功能需要中心、哪些權力應受到制衡，以及當中心失靈時，參與者是否能夠監督、替換或退出。所以，其實區塊鏈不等同於分散式帳本，還包含架構與智能合約所隱含的策略與制衡，當然還不夠智慧，所以稱為智能合約。",
          "中心化與去中心化並非二選一。系統可能在貨幣發行上高度集中，在交易執行上保有點對點特性；也可能在技術架構上分散，卻因治理權或基礎設施集中而形成新的權力中心。設計重點並非追求完全去中心化，而是在效率、公平與責任之間作出合適取捨。在全球隨時運作的需求下，可以量化的快速測度（包含信任）才能談如何能合適取捨。",
        ],
      },
      {
        title: "四、區塊鏈以外的價值交換方式",
        paragraphs: [
          "從交易執行來看，現金本身就具有點對點特性。雙方可以直接完成交易，不需要銀行、信用卡公司或支付平台即時批准，也不依賴網路。不過，現金的發行、法償地位與貨幣政策，仍由中央銀行或政府制度決定。",
          "現金雖有遺失、偽造、不易追蹤及不適合遠距交易等限制，卻說明電子化、點對點交易、去中心化與區塊鏈並不是同一件事。電子支付可以由單一平台管理；現金雖非數位工具，卻能由交易雙方直接使用；區塊鏈則可降低對單一帳本管理者的依賴，但未必更快或更便宜。交易也可以建立在局部信任上，例如商店允許熟客先記帳，再定期結算，或由社群共同記錄成員的付出與消費。這類制度不是完全排除中心，而是將信任限制在較小群體內，降低驗證與協調成本。",
          "薛老師也以早期 IOTA 的 Tangle 為例，說明分散式帳本不一定採用基本線性與少量分岔的區塊結構，也不一定要收手續費。Tangle 以有向無環圖（DAG）組織交易以應付 IOT 的大量交易，新交易需要核可先前交易，使多筆交易能平行加入系統。不過，系統仍需處理交易選擇、衝突判定與低活動時的安全性。早期 IOTA 主網曾依賴 Coordinator 發布里程碑，協助節點判斷交易是否確認，也反映分散式系統在發展初期可能仍需要額外協調機制。但是為了處理可能的相依交易，會成為IOTA 這類較理想化加速效能設計的瓶頸。",
          "訪談也談到 Tim Jenkin 與 Community Exchange System（CES）。CES 透過共同帳本記錄成員提供與取得的商品或服務，採用互惠信用（mutual credit）：提供服務的一方形成正餘額，接受服務的一方形成負餘額，用來記錄成員對社群的貢獻與義務，而非事先發行貨幣。時間銀行則以服務時間作為單位。參與者提供一小時服務後取得相應額度，再換取其他成員的服務。這些制度顯示，價值交換可以建立在不同的信任、記帳與治理安排上。Tim 來過本系演講表示，他的時間銀行可以在金融體系崩壞後成為金融界的諾亞方舟。因此，在採用區塊鏈以前，應先確認真正需要解決的是支付電子化、共同帳本、隱私、遠距交易，還是對單一平台的制衡。",
        ],
      },
      {
        title: "五、未來值得研究的問題",
        paragraphs: [
          "談到未來發展時，薛老師提醒，研究者不應只因某項技術受到關注，便跟風投入相似的研究。對資源有限的團隊而言，若與大型企業比較算力、資料與資本，難以形成優勢。研究仍需回到問題本身，思考現有方法忽略了什麼，以及哪些底層問題尚未解決。",
          "在區塊鏈領域，如何建立更有效率、公平且可擴展的共識與交易順序機制，仍是重要課題。系統需要提升效能，同時避免驗證與治理權集中於少數參與者，並降低不公平排序與同步成本。鏈上系統與現實世界的連結也仍有許多問題。外部資料由誰提供、如何驗證，以及資料錯誤時如何究責，不只涉及資訊工程，也牽涉金融制度、法律規範與治理設計。",
          "隱私與可追責性之間同樣需要平衡。公有鏈交易通常具有高度透明性，地址雖具假名性，卻不等於真正匿名。資料過度公開可能侵害隱私；若身分與交易完全匿名化，又可能提高調查與問責的難度。各種兩難三難的問題很多，真能解決才有機會跟大型企業一搏，當AI取代人力，爆肝利基不再時，用區塊鏈結合不互相信任的人一起合作，也許還有機會。",
        ],
      },
    ],
  },
];
